import { postResendNotification, postResendAllFailed, } from "@erp/shared/api/generated/wrappers/notification";
import { useInvalidateQueries } from "@erp/shared/composables/useInvalidateQueries";
import { queries } from "@erp/shared/queries";
import { showAlert } from "@erp/shared/utils/dialog";
import { getErrorMessage } from "@erp/shared/utils/error";
import { useMutation, useQuery } from "@tanstack/vue-query";
import { computed, ref } from "vue";
export const useNotificationLogAction = () => {
    const { invalidateQueries } = useInvalidateQueries();
    const page = ref(1);
    const limit = ref(50);
    const statusFilter = ref("");
    const eventTypeFilter = ref("");
    const startDate = ref("");
    const endDate = ref("");
    const queryParams = computed(() => ({
        page: page.value,
        limit: limit.value,
        ...(statusFilter.value ? { status: statusFilter.value } : {}),
        ...(eventTypeFilter.value ? { eventType: eventTypeFilter.value } : {}),
        ...(startDate.value ? { startDate: startDate.value } : {}),
        ...(endDate.value ? { endDate: endDate.value } : {}),
    }));
    const readLogsQueryOptions = computed(() => ({
        ...queries.notification.logs(queryParams.value),
    }));
    const readLogsQuery = useQuery(readLogsQueryOptions);
    const resendMutation = useMutation({
        mutationFn: (id) => postResendNotification(id),
        onSuccess: () => {
            showAlert("재발송 완료", "완료");
            invalidateQueries([queries.notification._def]);
        },
        onError: (err) => {
            showAlert(getErrorMessage(err), "재발송 실패");
        },
    });
    const resendAllFailedMutation = useMutation({
        mutationFn: () => postResendAllFailed(),
        onSuccess: (data) => {
            showAlert(`${data.updatedCount}건 재시도 등록 완료`, "완료");
            invalidateQueries([queries.notification._def]);
        },
        onError: (err) => {
            showAlert(getErrorMessage(err), "일괄 재시도 등록 실패");
        },
    });
    return {
        readLogsQuery,
        resendMutation,
        resendAllFailedMutation,
        page,
        limit,
        statusFilter,
        eventTypeFilter,
        startDate,
        endDate,
    };
};
